import { useContext } from "react";
import { Context } from "../context";

export const useRemainedSecond = () => useContext(Context);
